import privacyPolicies from "./privacyPolicies/reducer";
import auth from "./auth/reducer";
import common from "./common/reducer";
import mainPage from "./mainPage/reducer";
import requestCall from "./requestCall/reducer";

const rootReducer = {
  auth,
  common,
  mainPage,
  privacyPolicies,
  requestCall,
};

export default rootReducer;
